<template>
  <v-app style="background:#eee;">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;">AP 无线设备拓扑图</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="getList">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
      </v-menu>
    </v-app-bar>
    <v-content>
      <v-container style="padding: 0px;margin: 0px;">
        <div :id="canvasId">

        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  data() {
    return {
      loading: true,
      iot_id: '',
      prod_key: 'yqzn14dcomgF1Am7TX9s',
      dev_name: '5BD6F61C-86FF-4511-95D6-DCAE96CC7BF4',
      list: [],
      canvasId: 'canvas1',
      exdraw: null,
      timeout: null
    }
  },
  computed: {
  },
  watch: {

  },
  mounted() {
    this.init()
    // this.getList()
    setTimeout(this.checkTask, 2 * 1000);
  },
  created() {

  },
  destroyed() {
    var that = this
    if (that.exdraw) {
      that.exdraw.release()
      that.exdraw = null
    }
    if (that.timeout) {
      window.clearTimeout(that.timeout)
    }
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    init() {
      var that = this

      // console.log(pageHeight, pageWidth)

      // console.log(Window.ECX_exdraw, 77777777)
      var exdd = new Window.ECX_exdraw();
      that.exdraw = exdd
      exdd.id = this.canvasId

      that.$nextTick(() => {
        var pageHeight = document.body.clientHeight - 48
        var pageWidth = document.body.clientWidth
        exdd.width = pageWidth
        exdd.height = pageHeight
        setTimeout(exdd.render(), 2 * 1000);
      })
      // exdd.render();

      // console.log(exdd)
    },
    async getList() {
      var that = this
      var res = await that.$api.iot.submitServiceCmd({ prod_key: that.prod_key, dev_name: that.dev_name, role: 1, method: 'term_list', item: JSON.stringify({ }) })
      // console.log('submitServiceCmd.res', res)
      this.loading = false
      if (!res.success) {
        // that.$toast.warning(res.error_msg)
        return
      }
      var data = res.data

      console.log(data)
      // that.list = data.items

      if (that.exdraw) {
        that.exdraw.reset(data)
      }
    },
    // 检查任务
    async checkTask() {
      var that = this;

      if (that.timeout) {
        window.clearTimeout(that.timeout);
      }

      that.getList()

      that.timeout = setTimeout(that.checkTask, 2 * 1000);
    }

  }
}
</script>

<style scoped>
.us-v-badge >>> .v-badge__badge{
  height: 5px !important;
  width: 5px !important;
}

.us-list-item >>> .v-list-item__icon{
  min-width: 0.9rem;
}

</style>

